export const API_URL = "https://api.guestlist.kamis-apps.com/guest-list/api";
export const USER_ID = "2";
export const EVENT_NAME = "Lea-and-Nick-Wedding";